<div class="operator-value-container" fxLayout="row" *ngIf="property.input">
    <!-- Operator Selection -->
    <mat-form-field class="dynamic-width rule-operator-container" *ngIf="!property.fixed_operator">
        <mat-select class="rule-operator-select" panelClass="inline-panel" [(ngModel)]="operator"
            [placeholder]="'Select an operator to filter with' | translate" [disabled]="isDisabled || noEditAllowed"
            (selectionChange)="changeProperty()" required>

            <ng-container *ngIf="property.input === 'text'">
                <mat-option *ngFor="let operatorOption of textOperators" [value]="operatorOption.key">
                    {{ operatorOption.value }}
                </mat-option>
            </ng-container>
            <ng-container *ngIf="property.input === 'largetext'">
                <mat-option *ngFor="let operatorOption of largeTextOperators" [value]="operatorOption.key">
                    {{ operatorOption.value }}
                </mat-option>
            </ng-container>
            <ng-container *ngIf="property.input === 'integer' || property.input === 'decimal'">
                <mat-option *ngFor="let operatorOption of getOperators(property)" [value]="operatorOption.key">
                    {{ operatorOption.value }}
                </mat-option>
            </ng-container>
            <ng-container *ngIf="property.input === 'single select'">
                <mat-option *ngFor="let operatorOption of selectOperators" [value]="operatorOption.key">
                    {{ operatorOption.value }}
                </mat-option>
            </ng-container>
            <ng-container *ngIf="property.input === 'multiselect'">
                <mat-option *ngFor="let operatorOption of multiSelectOperators" [value]="operatorOption.key">
                    {{ operatorOption.value }}
                </mat-option>
            </ng-container>
            <ng-container *ngIf="property.input === 'autocomplete'">
                <mat-option *ngFor="let operatorOption of autoCompleteOperators" [value]="operatorOption.key">
                    {{ operatorOption.value }}
                </mat-option>
            </ng-container>
            <ng-container *ngIf="property.input === 'tags'">
                <mat-option *ngFor="let operatorOption of tagOperators" [value]="operatorOption.key">
                    {{ operatorOption.value }}
                </mat-option>
            </ng-container>

            <!-- Date Operators -->
            <mat-optgroup *ngIf="property.input === 'date'" [label]="'Relative time' | translate">
                <mat-option *ngFor="let operatorOption of dateOperators.relative" [value]="operatorOption.key">
                    {{ operatorOption.value }}
                </mat-option>
            </mat-optgroup>
            <mat-optgroup *ngIf="property.input === 'date'" [label]="'Absolute time' | translate">
                <mat-option *ngFor="let operatorOption of dateOperators.absolute" [value]="operatorOption.key">
                    {{ operatorOption.value }}
                </mat-option>
            </mat-optgroup>

            <ng-container *ngIf="property.input === 'url'">
                <mat-option *ngFor="let operatorOption of urlOperators" [value]="operatorOption.key">
                    {{ operatorOption.value }}
                </mat-option>
            </ng-container>
            <ng-container *ngIf="property.input === 'radio'">
                <mat-option *ngFor="let operatorOption of booleanOperators" [value]="operatorOption.key">
                    {{ operatorOption.value }}
                </mat-option>
            </ng-container>
            <ng-container *ngIf="property.input === 'binaryradio'">
                <mat-option *ngFor="let operatorOption of binaryBooleanOperators" [value]="operatorOption.key">
                    {{ operatorOption.value }}
                </mat-option>
            </ng-container>
        </mat-select>
    </mat-form-field>

    <!-- Input Fields -->
    <div class="rule-value-container" *ngIf="showInputField()" fxLayout="column">
        <!-- Text Input -->
        <mat-form-field class="rule-value-container" *ngIf="showInputField() && property.input === 'text'">
            <div class="regular-input">
                <input matInput aria-label="text-input" type="text" class="flex"
                    [disabled]="isDisabled || noEditAllowed" [required]="showInputField()" (blur)="applyWrapper()"
                    [(ngModel)]="value" (ngModelChange)="changePropertyValue()">
            </div>
        </mat-form-field>

        <!-- large-text type -->
        <mat-form-field class="rule-value-container" *ngIf="showInputField() && property.input === 'largetext'">
            <div class="regular-input">
                <input matInput aria-label="large-text-input" type="text" class="flex" (blur)="applyWrapper()"
                    [(ngModel)]="value" (ngModelChange)="changePropertyValue()" [disabled]="isDisabled || noEditAllowed"
                    [required]="showInputField()">
            </div>
        </mat-form-field>

        <!-- integer type -->
        <mat-form-field class="rule-value-container" *ngIf="showInputField() && property.input === 'integer'">
            <div class="regular-input">
                <input matInput aria-label="number-input" type="number" class="flex" (blur)="applyWrapper()"
                    [(ngModel)]="value" (ngModelChange)="changePropertyValue()" [disabled]="isDisabled || noEditAllowed"
                    [required]="!fixedRule">
            </div>
        </mat-form-field>

        <!-- decimal type -->
        <mat-form-field class="rule-value-container" *ngIf="showInputField() && property.input === 'decimal'">
            <div class="regular-input">
                <input matInput aria-label="decimal-input" type="number" class="flex" step=".01" (blur)="applyWrapper()"
                    [(ngModel)]="value" (ngModelChange)="changePropertyValue()" [disabled]="isDisabled || noEditAllowed"
                    required>
            </div>
        </mat-form-field>

        <!-- Single Select -->
        <mat-form-field class="rule-value-container" *ngIf="showInputField() && property.input === 'single select'">
            <div class="select-input" ng-class="vm.operator">
                <mat-select [(ngModel)]="selectedValue" (selectionChange)="changePropertyValue()"
                    [placeholder]="'Select a value' | translate" [disabled]="isDisabled || noEditAllowed" required>
                    <mat-option *ngFor="let option of selectOptions" [value]="option.id">{{ option.name }}</mat-option>
                </mat-select>
            </div>
        </mat-form-field>

        <!-- Multi Select -->
        <mat-form-field class="rule-value-container" *ngIf="showInputField() && property.input === 'multiselect'">
            <div class="select-input" ng-class="vm.operator">
                <mat-select [(ngModel)]="selectedValue" (selectionChange)="changePropertyValue()" multiple
                    [disabled]="isDisabled || noEditAllowed" [required]="!fixedRule">
                    <mat-option *ngFor="let option of selectOptions" [value]="option.id">{{ option.name }}</mat-option>
                </mat-select>
            </div>
        </mat-form-field>

        <!-- Autocomplete -->
        <mat-form-field class="rule-value-container" *ngIf="showInputField() && property.input === 'autocomplete'">
            <div class="auto-complete-input">

                <mat-chip-list [attr.aria-label]="property.label" [ngClass]="operator">
                    <mat-chip matTooltip="{{ chip.name }}" matTooltipPosition="above" *ngFor="let chip of valueChip"
                        class="chip-item" [ngClass]="'red-test'" (removed)="removeChip(chip)">
                        <span class="ellipsis contact-chip-name">{{ chip.name }}</span>
                        <button matChipRemove *ngIf="!(isDisabled || noEditAllowed)">×</button>
                    </mat-chip>
                </mat-chip-list>

                <input #controlledInput matInput [formControl]="searchedQuery" [readonly]="isDisabled || noEditAllowed"
                    autocomplete="off" [matAutocomplete]="auto" placeholder="" />

                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectAutocompleteOption($event)"
                    [displayWith]="displayFn" [autoActiveFirstOption]="true">
                    <mat-option *ngFor="let value of filteredOptions" [value]="value"
                        [ngClass]="{ 'translucent-25': value.disabled }">
                        <div class="ellipsis">{{ value.name }}</div>
                    </mat-option>
                </mat-autocomplete>

            </div>
        </mat-form-field>


        <!-- Tags (same as autocomplete) -->
        <mat-form-field class="rule-value-container" *ngIf="showInputField() && property.input === 'tags'">
            <div class="auto-complete-input">
                <label></label>

                <mat-chip-grid #chipList [attr.aria-label]="property.label" [ngClass]="operator">
                    <mat-chip *ngFor="let chip of valueChip" [ngClass]="chip.archived ? 'sf-chip-error' : ''"
                        (removed)="removeChip(chip)">
                        <div class="contact-chip-name">
                            {{ chip.name }}
                        </div>
                        <button matChipRemove *ngIf="!(isDisabled || noEditAllowed)">✕</button>
                    </mat-chip>

                    <input placeholder="" [matChipInputFor]="chipList" [matChipInputAddOnBlur]="false"
                        [matAutocomplete]="auto" [formControl]="searchedQuery" [readonly]="isDisabled || noEditAllowed"
                        [disabled]="isDisabled || noEditAllowed" autocomplete="off">
                </mat-chip-grid>

                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectAutocompleteOption($event)"
                    [displayWith]="displayFn" [autoActiveFirstOption]="true">
                    <mat-option *ngFor="let value of filteredOptions" [value]="value"
                        [ngClass]="{'translucent-25': value.disabled}">
                        <div class="ellipsis">{{ value.name }}</div>
                    </mat-option>
                </mat-autocomplete>

            </div>
        </mat-form-field>

        <!-- Date Inputs -->
        <div fxLayout="row"
            *ngIf="property.input === 'date' && operator !== 'after' && operator !== 'before' && operator !== 'on'">
            <mat-form-field class="rule-value-container">
                <input matInput type="number" [(ngModel)]="value" (blur)="applyWrapper()"
                    (ngModelChange)="changePropertyValue()" [disabled]="isDisabled || noEditAllowed" required>
            </mat-form-field>
            <div fxLayout="row" style="align-items: center;">
                <span style="margin: 0 5px;" translate>days</span>
            </div>
        </div>

        <mat-form-field class="rule-value-container date-picker"
            *ngIf="property.input === 'date' && (operator === 'after' || operator === 'before' || operator === 'on')">
            <input matInput [matDatepicker]="picker" [(ngModel)]="valueDate" (blur)="applyWrapper()"
                (ngModelChange)="changePropertyValue()" [disabled]="isDisabled || noEditAllowed" required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <!-- Between Inputs -->
        <mat-form-field class="rule-value-container"
            *ngIf="(operator === 'between' || operator === 'not_between') && (property.input === 'integer' || property.input === 'decimal')">
            <div class="regular-input">
                <input matInput type="number" [(ngModel)]="value2" (blur)="applyWrapper()"
                    (ngModelChange)="changePropertyValue()" [disabled]="isDisabled || noEditAllowed" [required]="(operator === 'between' || operator === 'not_between') && value !== null && value !== undefined">
            </div>
        </mat-form-field>
    </div>
</div>